import React, { Component } from 'react'
import Loader from 'react-loader-advanced'
import { GaugeChart } from '../../monitoring/components/charts'
import HttpClient from "../../../libs/http";
import './styles.css'
const queryString = require('query-string')
const http = new HttpClient()
const worker = null
var query = queryString.parse(window.location.search)

export default class OrdersCooktop extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loaded: false,
      hiddenAccount: true,
      data: {
        monday: null,
        tuesday: null,
        wednesday: null,
        thursday: null,
        friday: null,
        saturday: null,
        sunday: null,
        nextMonday: null,
      },
      total: null,
    }
  }

  getTotals = async () => {
    let date = query.date ? Date.toDate(query.date) : new Date()
    date = date.toString('yyyy-MM-dd')
    const data = await http.GET(
      '/api/pvt/orders/cooktop/totals' +
        '?from=' +
        Date.toDate(`${date}T00:00:00`).toString() +
        '&to=' +
        Date.toDate(`${date}T23:59:59`).toString() +
        '&squad=' +
        (query.squad || '*') +
        '&segment=' +
        (query.segment || '*') +
        '&origin=' +
        (query.origin || '*') +
        '&country=' +
        (query.country || '*') +
        '&lastYearShift=' +
        (query.lastYearShift || 'foward') +
        '&noChild=' +
        (query.noChild || 'false')
    )
    const newState = this.state
    newState.data = data.cooktopData.data
    newState.total = data.cooktopData.total
    newState.loaded = true
    this.setState(newState)
  }

  async componentWillMount() {
    await this.getTotals()
    worker = setInterval(this.getTotals, 30000);
  }

  componentWillUnmount() {
    if (worker) clearInterval(worker);
  }

  render() {
    return (
      <div>
        <Loader show={ !this.state.loaded } message={ 'Loading...' } backgroundStyle={ { backgroundColor: 'black' } }>
          <h3 className="mv0 f3 fw1 tc pv4 dn-l"> Top Countries</h3>
          <div className="pa0 mt4-l">
            <div className="overflow-x-scroll white overflow-hidden-l f6 ph2-l justify-around w-100">
              <div className="fl w-30 week flex">
                {this.state.total ? (
                  <OrdersGauge
                    data={this.state.total}
                    minHeight={700}
                    inner={'78%'}
                    outer={'100%'}
                    cx={450}
                    cy={400}
                  />
                  ) : (
                    false
                  )
                }
              </div>
              <div className="fl w-70">
                {this.state.data.monday ? (
                  <div className="fl w-25">
                    <OrdersGauge
                      data={this.state.data.monday}
                      inner={120}
                      outer={140}
                    />
                  </div>
                ) : (
                  false
                )}
                {this.state.data.tuesday ? (
                  <div className="fl w-25">
                    <OrdersGauge
                      data={this.state.data.tuesday}
                      inner={120}
                      outer={140}
                    />
                  </div>
                ) : (
                  false
                )}
                {this.state.data.wednesday ? (
                  <div className="fl w-25">
                    <OrdersGauge
                      data={this.state.data.wednesday}
                      inner={120}
                      outer={140}
                    />
                  </div>
                ) : (
                  false
                )}
                {this.state.data.thursday ? (
                  <div className="fl w-25">
                    <OrdersGauge
                      data={this.state.data.thursday}
                      inner={120}
                      outer={140}
                    />
                  </div>
                ) : (
                  false
                )}
                {this.state.data.friday ? (
                  <div className="fl w-25">
                    <OrdersGauge
                      data={this.state.data.friday}
                      inner={120}
                      outer={140}
                    />
                  </div>
                ) : (
                  false
                )}
                {this.state.data.saturday ? (
                  <div className="fl w-25">
                    <OrdersGauge
                      data={this.state.data.saturday}
                      inner={120}
                      outer={140}
                    />
                  </div>
                ) : (
                  false
                )}
                {this.state.data.sunday ? (
                  <div className="fl w-25">
                    <OrdersGauge
                      data={this.state.data.sunday}
                      inner={120}
                      outer={140}
                    />
                  </div>
                ) : (
                  false
                )}
                {this.state.data.nextMonday ? (
                  <div className="fl w-25">
                    <OrdersGauge
                      data={this.state.data.nextMonday}
                      inner={120}
                      outer={140}
                    />
                  </div>
                ) : (
                  false
                )}
              </div>
            </div>
          </div>
        </Loader>
      </div>
    )
  }
}
export class OrdersGauge extends Component {
  constructor(props) {
    super(props)
    this.state = {
      now: this.props.data.count,
      lastYear: this.props.data.lastYearCount,
      percent:
        this.props.data.count * 100 / this.props.data.lastYearCount,
    }
  }
  getColor = value => {
    if (value <= 20) return '#D9534F'
    if (value > 20 && value <= 98) return '#F0AD4E'
    if (value > 98) return '#5CB85C'
  }
  render() {
    const data = [
      {
        name: 'now',
        value: this.state.percent,
        fill: this.getColor(this.state.percent),
      },
    ]
    if (this.state.percent < 100) {
      data.push({
        name: 'left',
        value: 100 - this.state.percent,
        fill: '#000000',
      })
    }
    return (
      <div className="fl w-100 white flex">
        <GaugeChart
          data={data}
          color={this.getColor(this.state.percent)}
          legend={this.props.data.title}
          limit={this.props.data.lastYearCount}
          value={this.props.data.count}
          percent={this.state.percent - 100}
          inner={this.props.inner}
          outer={this.props.outer}
          minHeight={this.props.minHeight}
          size={300}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Orders/OrdersCooktop/index.js